<template>
  <header class="dashboard-header" :class="{ 
    'sidebar-collapsed': !is_sidebar_visible && !isMobile,
    'sidebar-open': is_sidebar_visible || isMobile 
  }">
    <div class="header-left">
      <button class="sidebar-toggle" @click="toggleSidebar">
        <i class="fas fa-bars"></i>
      </button>
      <h1 class="header-title">Partnerkapu</h1>
    </div>

    <div class="header-right">
      <!-- Értesítések -->
      <!-- <div class="notification-dropdown">
        <button class="notification-btn" @click="toggleNotifications">
          <i class="fas fa-bell"></i>
          <span class="notification-badge" v-if="unreadCount > 0">{{ unreadCount }}</span>
        </button>
        
        <div class="notification-menu" v-show="showNotifications">
          <div class="notification-header">
            <h6>Értesítések</h6>
            <button class="mark-all-read" @click="markAllRead">Összes olvasottnak jelölése</button>
          </div>
          <div class="notification-list">
            <div class="notification-item" v-for="notification in notifications" :key="notification.id">
              <div class="notification-content">
                <p>{{ notification.message }}</p>
                <small>{{ notification.time }}</small>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Felhasználó menü -->
      <div class="user-dropdown">
        <button class="user-btn" @click="toggleUserMenu">
          <img :src="user.avatar || '/images/user_empty.png'" :alt="user.name" class="user-avatar">
          <span class="user-name">{{ user.last_name }}</span>
          <i class="fas fa-chevron-down"></i>
        </button>
        <div class="user-menu" v-show="showUserMenu">
          <router-link to="/settings/me" class="menu-item" @click="showUserMenu = false">
            <i class="fas fa-gears"></i>
            Profil beallitasok
          </router-link>
          <hr class="menu-divider">
          <button class="menu-item logout-btn" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Kijelentkezés
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import authService from '@/services/authService'

export default {
  name: 'DashboardHeader',
  props: {
    is_sidebar_visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showNotifications: false,
      showUserMenu: false,
      unreadCount: 3,
      notifications: [
        { id: 1, message: 'Új rendelés érkezett', time: '5 perce' },
        { id: 2, message: 'Profil frissítve', time: '1 órája' },
        { id: 3, message: 'Új üzenet', time: '2 órája' }
      ],
      user: {},
      isMobile: false
    }
  },
  methods: {
    toggleSidebar() {
      // Desktop toggle
      if (window.innerWidth > 768) {
        this.$emit('toggle-sidebar')
      } else {
        // Mobile toggle
        document.dispatchEvent(new CustomEvent('toggle-mobile-sidebar'))
      }
    },

    toggleNotifications() {
      this.showNotifications = !this.showNotifications
      this.showUserMenu = false
    },

    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
      this.showNotifications = false
    },

    markAllRead() {
      this.unreadCount = 0
      this.showNotifications = false
    },

    async logout() {
      const result = await this.$swal.fire({
        title: 'Kijelentkezés',
        text: 'Biztosan ki szeretne jelentkezni?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Igen',
        cancelButtonText: 'Mégse'
      })

      if (result.isConfirmed) {
        authService.logout()
        this.$router.push('/login')
      }
    },

    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },

  mounted() {
    // Kattintás kívülre - menük bezárása
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showNotifications = false
        this.showUserMenu = false
      }
    })

    this.user = authService.getUser();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style scoped>
.dashboard-header {
  height: 60px;
  background: white;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  top: 0;
  right: 0;
  z-index: 998;
  transition: left 0.3s ease, width 0.3s ease;
  left: 250px;
  width: calc(100% - 250px);
}


.dashboard-header.sidebar-open {
  left: 250px;
  width: calc(100% - 250px);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.sidebar-toggle {
  background: none;
  border: none;
  font-size: 18px;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.sidebar-toggle:hover {
  background-color: #f8f9fa;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #495057;
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Értesítések */
.notification-dropdown {
  position: relative;
}

.notification-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.2s;
}

.notification-btn:hover {
  background-color: #f8f9fa;
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #dc3545;
  color: white;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

.notification-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 300px;
  z-index: 1001;
}

.notification-header {
  padding: 15px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-header h6 {
  margin: 0;
  font-weight: 600;
}

.mark-all-read {
  background: none;
  border: none;
  color: #007bff;
  font-size: 12px;
  cursor: pointer;
}

.notification-list {
  max-height: 300px;
  overflow-y: auto;
}

.notification-item {
  padding: 12px 15px;
  border-bottom: 1px solid #f8f9fa;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-content p {
  margin: 0 0 4px 0;
  font-size: 14px;
}

.notification-content small {
  color: #6c757d;
  font-size: 12px;
}

/* Felhasználó menü */
.user-dropdown {
  position: relative;
}

.user-btn {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.user-btn:hover {
  background-color: #f8f9fa;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-name {
  font-weight: 500;
  color: #495057;
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 1001;
  padding: 8px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  color: #495057;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.menu-divider {
  margin: 8px 0;
  border: none;
  border-top: 1px solid #e9ecef;
}

.logout-btn {
  color: #dc3545;
}

.logout-btn:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

@media (max-width: 768px) {
  .dashboard-header {
    left: 0;
    width: 100%;
  }
  
  .dashboard-header.sidebar-collapsed,
  .dashboard-header.sidebar-open {
    left: 0;
    width: 100%;
  }
  
  .header-title {
    display: none;
  }

  .user-name {
    display: none;
  }
}
</style>

